import React, { useMemo } from 'react';
import { AlarmClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { getOfferDeadline, spotsTakenPercent } from '../utils/offer';
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}

/** Bloque de urgencia que se sitúa justo encima de la tarjeta de precio. */
export function CountdownTimer() {
  const deadline = useMemo(() => getOfferDeadline(), []);
  const {
    hours,
    minutes,
    seconds,
    isExpired
  } = useCountdown(deadline);
  const units = [{
    value: hours,
    label: 'ore'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'sec'
  }];
  return <div className="rounded-3xl border border-red-600/40 bg-red-600/10 px-5 py-6 text-center sm:px-7" data-id="element-26" data-mp="15dw9yhx0zmg5">
      <p className="flex items-center justify-center gap-2 font-sans text-[11px] font-semibold uppercase tracking-[0.18em] text-red-400" data-id="element-27" data-mp="34qiaz7re137b">
        <AlarmClockIcon className="h-4 w-4" strokeWidth={2} aria-hidden="true" data-id="element-28" data-mp="2zsyqvr80dw7g" />
        Offerta di lancio — termina tra:
      </p>

      {isExpired ? <p className="mt-4 font-serif text-xl font-bold leading-snug text-stone-100" data-id="element-29" data-mp="1gzrvm4tn9y0a">
          L'offerta di lancio è terminata.
        </p> : <>
          <div className="mx-auto mt-5 grid max-w-sm grid-cols-3 gap-2 sm:gap-3" aria-hidden="true" data-id="element-30" data-mp="123sniu6jbxv5">
            {units.map(unit => <div key={unit.label} className="flex flex-col items-center justify-center rounded-2xl border border-zinc-800 bg-zinc-950 px-2 py-3 text-center" data-id="element-31" data-mp="171u6lf3ynx6m">
                <span className="block font-serif text-3xl font-bold leading-none text-stone-100 sm:text-4xl" data-id="element-32" data-mp="1zqj2mzq5tcbi">
                  {pad(unit.value)}
                </span>
                <span className="mt-1.5 block font-sans text-[10px] font-semibold uppercase tracking-[0.12em] text-stone-400" data-id="element-33" data-mp="1q0g5qofx3e7w">
                  {unit.label}
                </span>
              </div>)}
          </div>
          <p className="sr-only" role="timer" data-id="element-34" data-mp="2ihai8j0qpyyc">
            Mancano {hours} ore, {minutes} minuti e {seconds} secondi alla fine
            dell'offerta di lancio.
          </p>

          <div className="mt-6 border-t border-zinc-800 pt-5" data-id="element-35" data-mp="2ndmv8n3ma8vy">
            <div className="flex items-baseline justify-between gap-4 font-sans text-[10px] font-semibold uppercase tracking-[0.14em] text-stone-400" data-id="element-36" data-mp="2ne66xm2oc11j">
              <span data-id="element-37" data-mp="2edhnucyfbahs">Posti limitati di lancio</span>
              <span className="text-red-400" data-id="element-38" data-mp="2ecos071065ef">Ne restano pochi</span>
            </div>
            <div className="mt-3 h-2 w-full overflow-hidden rounded-full bg-zinc-800" role="progressbar" aria-valuenow={spotsTakenPercent} aria-valuemin={0} aria-valuemax={100} aria-label="Posti di lancio già presi" data-id="element-39" data-mp="29fg6bwgnbj8f">
              <div className="h-full rounded-full bg-red-600" style={{
            width: `${spotsTakenPercent}%`
          }} data-id="element-40" data-mp="1zobv97u3ciiv" />
            </div>
            <p className="mt-2 text-right font-sans text-[11px] text-stone-400" data-id="element-41" data-mp="1qnx3pqqja76x">
              {spotsTakenPercent}% dei posti presi
            </p>
          </div>
        </>}
    </div>;
}